import React, { Component } from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/ext-language_tools';
export default class ExternalSourceBodyJSON extends Component {
  state = {
    jsonEditor: '',
  };

  editorMounted = (editor) => {
    this.props.jsonEditorMounted(editor);
    this.setState({ jsonEditor: editor });
  };

  handleHighlightJsonFields = () => {
    //Attempting to highlight dynamic values in the JSON editor.
    const { jsonEditor } = this.state;
    const { highlightFields } = this.props;
    const editor = jsonEditor ? jsonEditor : '';
    if (editor) {
      const jsonEditorElem = document.querySelector('.ace_content');
      if (jsonEditorElem) {
        const allJsonValues = jsonEditorElem.querySelectorAll(
          '.ace_layer.ace_text-layer .ace_line',
        );
        allJsonValues.forEach((jsonValue) => {
          const jsonValueElem = jsonValue.querySelector('span[class^="ace_string"]');
          const jsonStringValue = jsonValueElem ? jsonValueElem.textContent : '';
          const textContent = jsonStringValue;

          if (textContent && textContent.includes('{{')) {
            if (highlightFields) {
              if (textContent.includes('{{environment_variable.')) {
                jsonValueElem.classList.add('badge-warning', 'badge-pill');
              } else if (textContent.includes('{{current_user.')) {
                jsonValueElem.classList.add('badge-info', 'badge-pill');
              } else if (
                textContent.includes('{{current_session.') ||
                textContent.includes('{{form_data_session.')
              ) {
                jsonValueElem.classList.add('badge-success', 'badge-pill');
              } else if (textContent.includes('{{PC::')) {
                jsonValueElem.classList.add('badge-brand-green', 'badge-pill');
              } else {
                jsonValueElem.classList.add('badge-primary', 'badge-pill');
              }
            } else {
              jsonValueElem.classList.remove('badge-primary', 'badge-pill');
              jsonValueElem.classList.remove('badge-success', 'badge-pill');
              jsonValueElem.classList.remove('badge-warning', 'badge-pill');
              jsonValueElem.classList.remove('badge-info', 'badge-pill');
              jsonValueElem.classList.remove('badge-theme', 'badge-pill');
              jsonValueElem.classList.remove('badge-brand-green', 'badge-pill');
            }
          }
        });
      }
    }
  };

  handleEditorValidation = (markers) => {
    // model markers
    markers.forEach((marker) =>
      console.log('%c*** Body JSON Validate:', 'color:yellow', marker.message),
    );
  };

  render() {
    const { bodyJSON, handleBodyJSON } = this.props;
    return (
      <>
        <div className="row">
          <div className="col-12">
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <AceEditor
                    height="250px"
                    width="100%"
                    mode="json"
                    theme="github"
                    value={bodyJSON}
                    onChange={handleBodyJSON}
                    onValidate={this.handleEditorValidation}
                    onLoad={this.editorMounted}
                    showPrintMargin={false}
                    setOptions={{
                      enableBasicAutocompletion: true,
                      enableLiveAutocompletion: true,
                      enableAutoIndent: true,
                      enableSnippets: true,
                    }}
                    editorProps={{ $blockScrolling: true }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.handleHighlightJsonFields()}
      </>
    );
  }
}
